import Vue from "vue";
import Vuex from "vuex";

//Import vuex modules
import reachApiBody from "./modules/reachApiBody";
import reachForm from "./modules/reachForm";
import reachResults from "./modules/reachResults";
import siteReachApiBody from "./modules/siteReachApiBody";
import siteReachForm from "./modules/siteReachForm";
import campaignReachForm from "./modules/campaignReachForm";
import campaignReachApiBody from "./modules/campaignReachApiBody";
import campaignReachResults from "./modules/campaignReachResults";
import searchApiBody from "./modules/searchApiBody";
import siteApiBody from "./modules/siteApiBody";
import campaignApiBody from "./modules/campaignApiBody";
import campaignResults from "./modules/campaignResults";
import systemInfo from "./modules/systemInfo";
import searchResults from "./modules/searchResults";
import siteResults from "./modules/siteResults";
import siteReachResults from "./modules/siteReachResults";
import targetGroups from "./modules/targetGroups";
import genres from "./modules/genres";
import auth from "./modules/auth";
import config from "./modules/config";
import toplist from "./modules/toplist";
import cookie from "./modules/cookie";
import consumptionApiBody from "./modules/consumptionApiBody"
import consumptionResults from "./modules/consumptionResults"

//Load vuex
Vue.use(Vuex);

//create store
const store = new Vuex.Store({
  modules: {
    auth,
    reachApiBody,
    reachForm,
    siteReachApiBody,
    siteReachForm,
    campaignReachForm,
    searchApiBody,
    siteApiBody,
    campaignApiBody,
    campaignResults,
    campaignReachApiBody,
    campaignReachResults,
    systemInfo,
    searchResults,
    siteResults,
    targetGroups,
    reachResults,
    siteReachResults,
    genres,
    config,
    toplist,
    cookie,
    consumptionApiBody,
    consumptionResults
  },
});

export default store;
